<template>
  <b-col offset="1">
    <column-picker :column="subColumn" :required="isRequired" @change="updateSubColumn"
                   :columnSpecCategories="columnSpecCategories" :reportType="reportType" :report="report"
                   defaultOptionText="Please choose an option" :isGrouping="false" :isSubGrouping="false"
                   :isAggregate="isSubColumnAggregate" :hasLabel="false" :allowedDataTypes="allowedDataTypes">
    </column-picker>
  </b-col>
</template>

<script>

export default {
  name: 'converter-column-options',
  props: ['column', 'columnSpec', 'isRequired', 'columnSpecCategories', 'reportType', 'report', 'isRequired', 'isAggregate'],
  components: { 'column-picker': () => import('@/components/reports/ColumnPicker') },
  data () {
    return {
      subColumn: this.column.sub_columns[0] || { column_id: null, label: null, sub_columns: [], options: {} }
    }
  },
  computed: {
    allowedDataTypes () {
      return this.columnSpec.component_column_data_types
    },
    isSubColumnAggregate () {
      if (this.columnSpec.aggregation === 'aggregate' && this.isAggregate) {
        return false
      } else {
        return this.isAggregate
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    updateSubColumn () {
      this.column.sub_columns[0] = this.subColumn
      this.emitChange()
    },
    emitChange () {
      this.$emit('change', this.column)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/ConverterColumnOptions.vue